import { DialogContent, DialogActions, Box } from '@mui/material';
import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import { FormWrapper, Typo, GeneralInfo, SaveButton } from '../../styles';
import { useForm } from 'react-hook-form';
import { AddAccomplishmentModel } from '../../../../../../../interfaces/types/User';
import { InputField } from '../../../../../InputField/InputField';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAddAccomplishment } from '../../../../../../../rq/hooks/useEditProfile.mutation';
import { AddAccomplishmentSchema } from '../../../../../../../validators/EditProfile.validator';
import { months } from '../../monthYear';
import {
  BootstrapDialog,
  BootstrapDialogTitle,
} from '../../../../../../../../src/components/BootstrapDialog/BootstrapDialog';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { year } from '../../../../../../../static';
import { useGetAllAccomplishmentsQuery } from '../../../../../../../rq/hooks/useQueries';
import Select from '../../../../../../../components/Select/Select';

export default function AddAccomplishment({ open, setOpen }: any) {
  const { t } = useTranslation();
  const methods = useForm<AddAccomplishmentModel>({
    resolver: yupResolver(AddAccomplishmentSchema(t)),
  });
  const { data: accomplishments = [] } = useGetAllAccomplishmentsQuery();

  // react mutation
  const { mutate: addAccomplishmentMutation, isLoading } =
    useAddAccomplishment();
  // destructures
  const {
    register,
    handleSubmit,
    formState: {
      errors: { description, accomplishmentTypeId, startMonth, startYear },
    },
  } = methods;

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async (data: AddAccomplishmentModel) => {
    addAccomplishmentMutation(data, {
      onSuccess: () => {
        setOpen(false);
        toast.success(t('successMessage.admin_verification'));
      },
    });
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
      >
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
          >
            {t('editProfile.edit_candidate_profile.accomplishment.title_add')}
          </BootstrapDialogTitle>
          <DialogContent dividers>
            <FormWrapper>
              <div>
                <Typo>
                  {t('editProfile.edit_candidate_profile.general_info')}
                </Typo>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{ mr: 1 }}
                  error={!!accomplishmentTypeId}
                >
                  <InputLabel id="test-select-label">
                    {t(
                      'editProfile.edit_candidate_profile.accomplishment.name'
                    )}
                  </InputLabel>
                  <Select
                    defaultValue=""
                    options={accomplishments}
                    variant="outlined"
                    input={
                      <OutlinedInput
                        label={t(
                          'editProfile.edit_candidate_profile.accomplishment.name'
                        )}
                      />
                    }
                    {...register('accomplishmentTypeId')}
                    fieldError={accomplishmentTypeId}
                  />
                </FormControl>
              </div>
              <div>
                <Typo>
                  {t('editProfile.edit_candidate_profile.start_date')}
                </Typo>
                <GeneralInfo>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ mr: 1 }}
                    error={!!startMonth}
                  >
                    <InputLabel id="test-select-label">
                      {t('editProfile.edit_candidate_profile.month')}
                    </InputLabel>
                    <Select
                      defaultValue=""
                      options={months}
                      variant="outlined"
                      input={
                        <OutlinedInput
                          label={t('editProfile.edit_candidate_profile.month')}
                        />
                      }
                      {...register('startMonth')}
                      fieldError={startMonth}
                    />
                  </FormControl>

                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ mr: 1 }}
                    error={!!startYear}
                  >
                    <InputLabel id="test-select-label">
                      {t('editProfile.edit_candidate_profile.year')}
                    </InputLabel>
                    <Select
                      defaultValue=""
                      options={year()}
                      variant="outlined"
                      input={
                        <OutlinedInput
                          label={t('editProfile.edit_candidate_profile.year')}
                        />
                      }
                      {...register('startYear')}
                      fieldError={startYear}
                    />
                  </FormControl>
                </GeneralInfo>
              </div>
              <div>
                <Typo>{t('editProfile.edit_candidate_profile.end_date')}</Typo>
                <GeneralInfo>
                  <FormControl fullWidth size="small" sx={{ mr: 1 }}>
                    <InputLabel id="test-select-label">
                      {t('editProfile.edit_candidate_profile.month')}
                    </InputLabel>
                    <Select
                      defaultValue=""
                      options={months}
                      variant="outlined"
                      input={
                        <OutlinedInput
                          label={t('editProfile.edit_candidate_profile.month')}
                        />
                      }
                      {...register('endMonth')}
                    />
                  </FormControl>

                  <FormControl fullWidth size="small" sx={{ mr: 1 }}>
                    <InputLabel id="test-select-label">
                      {t('editProfile.edit_candidate_profile.year')}
                    </InputLabel>
                    <Select
                      defaultValue=""
                      options={year()}
                      variant="outlined"
                      input={
                        <OutlinedInput
                          label={t('editProfile.edit_candidate_profile.year')}
                        />
                      }
                      {...register('endYear')}
                    />
                  </FormControl>
                </GeneralInfo>
              </div>

              <Typo>{t('editProfile.edit_candidate_profile.description')}</Typo>
              <InputField
                multiline
                fullWidth
                size="small"
                fieldError={description}
                {...register('description')}
              />
            </FormWrapper>
          </DialogContent>
          <DialogActions>
            <SaveButton
              loading={isLoading}
              variant="contained"
              type="submit"
              autoFocus
            >
              {t('editProfile.edit_candidate_profile.save')}
            </SaveButton>
          </DialogActions>
        </Box>
      </BootstrapDialog>
    </div>
  );
}
